import Button from "../../components/ui/Button";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changeAdminPassword, getAuthenticatorStatus } from "../../services/authService";
import { AuthenticatorStatus } from "../../types/auth";
import { logout, replaceSessionTokens } from "../../redux/authSlice";
import { getTokenExpiration } from "../../utils/tokenUtils";
import { passwordError } from "../../utils/passwordValidation";
import { getApiErrorMessage } from "../../utils/apiError";

export default function AccountSecurityPanel() {
  const dispatch = useDispatch();
  const [status, setStatus] = useState<AuthenticatorStatus | null>(null);
  const [statusError, setStatusError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    let cancelled = false; setStatusError("");
    getAuthenticatorStatus().then(value => { if (!cancelled) setStatus(value); }).catch(err => { if (!cancelled) setStatusError(getApiErrorMessage(err)); });
    return () => { cancelled = true; };
  }, [attempt]);
  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    const validation = passwordError(newPassword, confirmNewPassword);
    if (validation) { setError(validation); return; }
    setBusy(true); setError(""); setMessage("");
    try {
      const pair = await changeAdminPassword({ currentPassword, newPassword, confirmNewPassword });
      const exp = getTokenExpiration(pair.accessToken);
      if (!exp || exp * 1000 <= Date.now() || !pair.refreshToken) { dispatch(logout()); return; }
      dispatch(replaceSessionTokens({ accessToken: pair.accessToken, refreshToken: pair.refreshToken, exp }));
      setCurrentPassword(""); setNewPassword(""); setConfirmNewPassword("");
      setMessage("Password changed. Your other sessions have been signed out.");
    } catch (err) { setError(getApiErrorMessage(err)); }
    finally { setBusy(false); }
  };
  return <section className="integration-panel"><h2>Account security</h2>
    {statusError && <p className="integration-error" role="alert">{statusError} <Button onClick={() => setAttempt(value => value + 1)}>Retry authenticator status</Button></p>}
    {status && <p>Authenticator: {status.enabled ? "Enabled" : "Not enrolled"}{status.lastVerifiedAt ? ` · Last verified ${new Date(status.lastVerifiedAt).toLocaleString()}` : ""}</p>}
    <h3>Change password</h3>
    {message && <p className="integration-success" role="status">{message}</p>}
    {error && <p className="integration-error" role="alert">{error}</p>}
    <form className="integration-form" onSubmit={submit}>
      <label>Current password<input type="password" autoComplete="current-password" value={currentPassword} onChange={event => setCurrentPassword(event.target.value)} required disabled={busy} /></label>
      <label>New password<input type="password" autoComplete="new-password" minLength={8} maxLength={72} value={newPassword} onChange={event => setNewPassword(event.target.value)} required disabled={busy} /></label>
      <label>Confirm new password<input type="password" autoComplete="new-password" maxLength={72} value={confirmNewPassword} onChange={event => setConfirmNewPassword(event.target.value)} required disabled={busy} /></label>
      <p className="integration-hint">Use uppercase and lowercase letters, a number, and a special character.</p>
      <button className="primary" disabled={busy}>{busy ? "Saving..." : "Change password"}</button>
    </form>
  </section>;
}
